//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionFade from '../transitions/Fade.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: "AppProduct",
  props: ['product', 'index'],
  components: {
    TransitionFade
  },
  computed: {
    ...mapGetters(['allProducts', 'selections', 'width']),
    model: {
      get() {
        return this.product.id;
      },
      set(value) {
        this.updateSelection({ index: this.index, id: value });
      }
    }
  },
  methods: {
    ...mapMutations(['updateSelection']),
  }
}
